/*
	Generated on 08/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import React, { useContext } from 'react';
import { useNavigate, Link } from "react-router";

import { useAuth } from '@/commons/auth';
import { Button, Detail, VisualizationAttr, Modal, Spinner } from '@/commons/components';

import deleteMataKuliah from '../services/deleteMataKuliah';
import deletemembergrupMataKuliah from '../services/deletemembergrupMataKuliah';
import deleteAllMemberMataKuliah from '../services/deleteAllMemberMataKuliah';

import * as Layouts from "@/commons/layouts";


const DetailMataKuliah = ({ data }) => {
    const { checkPermission } = useAuth();
    const navigate = useNavigate();
    const [showModalKonfirmasiHapusMataKuliah, setShowModalKonfirmasiHapusMataKuliah] = React.useState(false); 
    const [showModalKonfirmasiHapusMataKuliahdiDalamGrup, setShowModalKonfirmasiHapusMataKuliahdiDalamGrup] = React.useState(false); 
    const [showModalKonfirmasiHapusGrupMataKuliah, setShowModalKonfirmasiHapusGrupMataKuliah] = React.useState(false); 
    
    const ubahMataKuliah = async () => {
      navigate(
        '/matakuliah/ubah?'
        + `id=${data.id}`
        
      );
    };
    
  
    const hapus = async () => {
      await deleteMataKuliah({
        id: data.id,
      });
      navigate('/matakuliah');
    };

    const hapusMemberGrup = async () => {
      await deletemembergrupMataKuliah({
        id: data.id,
      });
      navigate('/matakuliah/:id');
    };

    const hapusGrup = async () => {
      await deleteAllMemberMataKuliah({
        grupMataKuliahId: data.grupMataKuliahId,
      });
      navigate('/matakuliah/:id');
    };
  
  return (
    <Layouts.DetailComponentLayout
      item={data}
      itemsAttrs={[
        {
          id: "kode",
          condition: "",
          label: "Kode",
          featureName: "kode",
        }
        ,
        {
          id: "nama",
          condition: "",
          label: "Nama",
          featureName: "nama",
        }
        ,
        {
          id: "sKS",
          condition: "",
          label: "SKS",
          featureName: "sks",
        }
        ,
        {
          id: "term",
          condition: "",
          label: "Term",
          featureName: "term",
        }
        ,
        {
          id: "kurikulum",
          condition: "",
          label: "Kurikulum",
          featureName: "kurikulumName",
        }
        
      ]}
      itemsModals={[
        <Modal
           isShow={showModalKonfirmasiHapusMataKuliah}
           title={"Konfirmasi Hapus Mata Kuliah"}
           text={"Are you sure want to proceed?"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusMataKuliah(false)}>Batal</Button></Link>
          <Button
            variant="danger"
            onClick={() => hapus()}
          >
            Hapus
          </Button>
        </Modal>,
        <Modal
           isShow={showModalKonfirmasiHapusMataKuliahdiDalamGrup}
           title={"Konfirmasi Hapus Mata Kuliah di Dalam Grup"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusMataKuliahdiDalamGrup(false)}>Batal</Button></Link>
          <Button
            variant="danger"
            onClick={() => hapusMemberGrup()}
          >
            Hapus
          </Button>
        </Modal>,
        <Modal
           isShow={showModalKonfirmasiHapusGrupMataKuliah}
           title={"Konfirmasi Hapus Grup Mata Kuliah"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusGrupMataKuliah(false)}>Batal</Button></Link>
          <Button
            variant="danger"
            onClick={() => hapusGrup()}
          >
            Hapus
          </Button>
        </Modal>
        
      ]}
    />
  );
};

export default DetailMataKuliah;
